import { render, staticRenderFns } from "./rencana_publish.vue?vue&type=template&id=58ff7158&"
import script from "./rencana_publish.vue?vue&type=script&lang=js&"
export * from "./rencana_publish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports